import { render, staticRenderFns } from "./InPagePermission.vue?vue&type=template&id=47c8b5fa&scoped=true&"
import script from "./InPagePermission.vue?vue&type=script&lang=ts&"
export * from "./InPagePermission.vue?vue&type=script&lang=ts&"
import style0 from "./InPagePermission.vue?vue&type=style&index=0&id=47c8b5fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8b5fa",
  null
  
)

export default component.exports